// extracted by mini-css-extract-plugin
module.exports = {"warning-notification":"_3V-YoQ4eJ8","warningNotification":"_3V-YoQ4eJ8"};
    if(module.hot) {
      // 1597843250271
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  